import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../auth-guard.service';
import { DocumentManagementComponent } from './document-management/document-management.component';

const routes: Routes = [
  {
    path: 'agent-document',
    component: DocumentManagementComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class DocumentManagementRoutingModule {}
